module.exports = __webpack_public_path__ + "static/img/check-circle-outline-green.828e94b1.svg";